/**
 *
 * @type {{shortMonths: String[], longMonths: String[], shortDays: String[], longDays: String[], d: Function, D: Function, j: Function, l: Function, N: Function, S: Function, w: Function, z: Function, W: Function, F: Function, m: Function, M: Function, n: Function, t: Function, L: Function, o: Function, Y: Function, y: Function, a: Function, A: Function, B: Function, g: Function, G: Function, h: Function, H: Function, i: Function, s: Function, u: Function, e: Function, I: Function, O: Function, P: Function, T: Function, Z: Function, c: Function, r: Function, U: Function}}
 */
import {getNumericValue} from '@/library/math';
import {dayNames, dayNamesShort, monthNames, monthNamesShort} from '../../library/date';

const dateFormat = {
    // translation for german date
    shortMonths: [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
    ],
    longMonths: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    shortDays: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa',
    ],
    longDays: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
    ],

    // Day

    /**
     * Day number, with leading zero
     * @returns {String}
     */
    d: function()
    {
        return (this.getDate() < 10 ? '0' : '') + this.getDate();
    },

    /**
     * short day name
     *
     * @return {String}
     */
    D: function()
    {
        return dateFormat.shortDays[this.getDay()];
    },

    /**
     * day number
     *
     * @returns {Number}
     */
    j: function()
    {
        return this.getDate();
    },

    /**
     * Day long name
     *
     * @returns {String}
     */
    l: function()
    {
        return dateFormat.longDays[this.getDay()];
    },
    /**
     * Day number of week (ISO-8601)
     *
     * @return {Number}
     */
    N: function()
    {
        return this.getDay() || 7;
    },

    /**
     * english day suffix
     *
     * @return {String}
     */
    S: function()
    {
        return (this.getDate() % 10 === 1 && this.getDate() !== 11 ? 'st' : (this.getDate() % 10 === 2 && this.getDate() !== 12 ? 'nd' : (this.getDate()
        % 10
        === 3
        && this.getDate()
        !== 13 ? 'rd' : 'th')));
    },

    /**
     * Day number of week
     *
     * @returns {Number}
     */
    w: function()
    {
        return this.getDay();
    },

    /**
     * Day of year
     *
     * @returns {Number}
     */
    z: function()
    {
        var d = new Date(this.getFullYear(), 0, 1);
        return Math.ceil((this - d) / 86400000);
    },

    // Week

    /**
     * Week number of year
     *
     * @return {Number|String}
     */
    W: function()
    {
        var d = new Date(this.getTime()),
            W;
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        W = Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 86400000) + 1) / 7);
        return W <= 9 ? '0' + W : W;
    },

    /**
     * get week with year
     *
     * @return {String}
     */
    Q: function()
    {
        var d = new Date(this.getTime()),
            W;
        d.setHours(0, 0, 0);
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        W = Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 86400000) + 1) / 7);
        return d.getFullYear() + 'W' + (W < 9 ? '0' + W : W);
    },

    // Month

    /**
     * Month long name
     *
     * @return {String}
     */
    F: function()
    {
        return dateFormat.longMonths[this.getMonth()];
    },
    // Month number with leading zero
    m: function()
    {
        return (this.getMonth() < 9 ? '0' : '') + (this.getMonth() + 1);
    },

    /**
     * Month short name
     *
     * @return {String}
     */
    M: function()
    {
        return dateFormat.shortMonths[this.getMonth()];
    },

    /**
     * Month number
     *
     * @returns {Number}
     */
    n: function()
    {
        return this.getMonth() + 1;
    },

    /**
     * Number of days in the given month
     *
     * @returns {Number}
     */
    t: function()
    {
        var date = new Date(this.getFullYear(), this.getMonth() + 1, 0);
        return date.getDate();
    },

    // Year

    /**
     * leap  year [ true | false ]
     * @return {Boolean}
     */
    L: function()
    {
        var year = this.getFullYear();
        return (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0));
    },

    o: function()
    {
        var d = new Date(this.getTime());
        d.setDate(d.getDate() - ((this.getDay() + 6) % 7) + 3);
        return d.getFullYear();
    },
    // Year number
    /**
     * @return {Number}
     */
    Y: function()
    {
        return this.getFullYear();
    },

    /**
     * Two digit years number
     *
     * @returns {String}
     */
    y: function()
    {
        return ('' + this.getFullYear()).substr(2);
    },

    // Time

    /**
     * Lowercase Ante meridiem (am) and Post meridiem (pm)
     *
     * @returns {String}
     */
    a: function()
    {
        return this.getHours() < 12 ? 'am' : 'pm';
    },

    /**
     * Uppercase Ante meridiem (am) and Post meridiem (pm)
     * @return {String}
     */
    A: function()
    {
        return this.getHours() < 12 ? 'AM' : 'PM';
    },

    /**
     * Swatch Internet time
     *
     * @return {Number}
     */
    B: function()
    {
        return Math.floor((((this.getUTCHours() + 1) % 24) + this.getUTCMinutes() / 60 + this.getUTCSeconds() / 3600) * 1000 / 24);
    },

    /**
     * 12-hour format of an hour without leading zeros
     *
     * @returns {Number}
     */
    g: function()
    {
        return this.getHours() % 12 || 12;
    },

    /**
     * 24-hour format of an hour without leading zeros
     *
     * @return {Number}
     */
    G: function()
    {
        return this.getHours();
    },

    /**
     * 12-hour format of an hour with leading zeros
     *
     * @returns {String}
     */
    h: function()
    {
        return ((this.getHours() % 12 || 12) < 10 ? '0' : '') + (this.getHours() % 12 || 12);
    },

    /**
     * 24-hour format of an hour with leading zeros
     *
     * @return {String}
     */
    H: function()
    {
        return (this.getHours() < 10 ? '0' : '') + this.getHours();
    },

    /**
     * Minutes with leading zeros
     *
     * @returns {String}
     */
    i: function()
    {
        return (this.getMinutes() < 10 ? '0' : '') + this.getMinutes();
    },

    /**
     * Seconds, with leading zeros
     *
     * @returns {String}
     */
    s: function()
    {
        return (this.getSeconds() < 10 ? '0' : '') + this.getSeconds();
    },

    /**
     * Microseconds
     *
     * @returns {String}
     */
    u: function()
    {
        var m = this.getMilliseconds();
        return (m < 10 ? '00' : (m < 100 ? '0' : '')) + m;
    },

    /**
     * Timezone
     *
     * @returns {String}
     */
    e: function()
    {
        return this.T();
    },

    /**
     * @return {Number}
     */
    I: function()
    {
        var DST = null;
        for (var i = 0; i < 12; ++i)
        {
            var d      = new Date(this.getFullYear(), i, 1);
            var offset = d.getTimezoneOffset();

            if (DST === null)
            {
                DST = offset;
            }
            else if (offset < DST)
            {
                DST = offset;
                break;
            }
            else if (offset > DST)
            {
                break;
            }
        }
        return (this.getTimezoneOffset() === DST) | 0;
    },

    /**
     * @return {String}
     */
    O: function()
    {
        return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.abs(this.getTimezoneOffset() / 60)) + '00';
    },

    /**
     * @return {String}
     */
    P: function()
    {
        return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.abs(this.getTimezoneOffset() / 60)) + ':00';
    },

    /**
     * @return {String}
     */
    T: function()
    {
        var m = this.getMonth();
        this.setMonth(0);
        var result = this.toTimeString().replace(/^.+ \(?([^)]+)\)?$/, '$1');
        this.setMonth(m);
        return result;
    },

    /**
     * @return {Number}
     */
    Z: function()
    {
        return -this.getTimezoneOffset() * 60;
    },

    // Full Date/Time

    /**
     * ISO 8601 Date
     *
     * @returns {String}
     */
    c: function()
    {
        return dateHelper('Y-m-d\\TH:i:sP');
    },

    /**
     * RFC 2822 formatted date
     *
     * @returns {String}
     */
    r: function()
    {
        return this.toString();
    },

    /**
     * Unix timestamp
     *
     * @returns {Number}
     */
    U: function()
    {
        return parseInt(this.getTime() / 1000);
    },
};

export function getDateFormat(format = 'd.m.Y', type)
{
    if ('datetime' === type)
    {
        format += ' H:i';
    }
    else if ('time' === type)
    {
        format = 'H:i';
    }

    return format;
}

/**
 *
 * @param parse
 * @param {string|null|Date} relationDate
 * @returns {false|Date}
 */
export function parseDate(parse, relationDate = null)
{
    if ('string' === typeof parse)
    {
        parse = parse.toLowerCase();
        parse = getNumericValue(parse);
    }

    if (relationDate !== null && !(relationDate instanceof Date))
    {
        relationDate = parseDate(relationDate);
    }

    let date = false;
    let days;

    if ('undefined' === typeof parse || null === parse || 'today' === parse || 'heute' === parse || 'h' === parse)
    {
        date = relationDate || new Date();
    }
    else if (parse instanceof Date)
    {
        date = parse;
    }
    else if (typeof parse === 'number' && isFinite(parse))
    {
        /** 62985600000ms = 1971-12-31 */
        if (parse < 62985600000)
        {
            parse *= 1000;
        }

        date = new Date(parse);
    }
    else if ('tomorrow' === parse || 'morgen' === parse)
    {
        date = relationDate || new Date();
        date.setDate(date.getDate() + 1);
    }
    else if ('overmorrow' === parse || 'übermorgen' === parse)
    {
        date = relationDate || new Date();
        date.setDate(date.getDate() + 2);
    }
    else if ('yesterday' === parse || 'gestern' === parse)
    {
        date = relationDate || new Date();
        date.setDate(date.getDate() - 1);
    }
    else if ('ereyesterday' === parse || 'vorgestern' === parse)
    {
        date = relationDate || new Date();
        date.setDate(date.getDate() - 2);
    }
    else if ('string' === typeof parse)
    {
        /** @var {number[]} */
        let mysqlDate;

        if ((days = parse.match(/(?:in |\+ ?)(\d+) ?(tage?n?|days?)/i)))
        {
            date = relationDate || new Date();
            date.setDate(date.getDate() + parseInt(days[1]));
        }
        else if ((days = parse.match(/(?:vor |- ?)(\d+) ?(tage?n?|days?(?: ago)?)/i)))
        {
            date = relationDate || new Date();
            date.setDate(date.getDate() - parseInt(days[1]));
        }
        // ISO-Date
        else if ((mysqlDate = parse.match(/^(\d{2,4})-(\d{1,2})-(\d{1,2})(?: (\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/)))
        {
            if ('undefined' !== typeof mysqlDate[4])
            {
                // January: JS: Month 0, MySQL: Month 1 -> mysqlDate[2]-1
                date = new Date(mysqlDate[1], mysqlDate[2] - 1, mysqlDate[3], mysqlDate[4], mysqlDate[5], (mysqlDate[6] || 0));
            }
            else
            {
                date = new Date(mysqlDate[1], mysqlDate[2] - 1, mysqlDate[3]);
            }
        }
        // German-Date
        else if ((mysqlDate = parse.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})(?: (\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/)))
        {
            if ('undefined' !== typeof mysqlDate[4])
            {
                // January: JS: Month 0, MySQL: Month 1 -> mysqlDate[2]-1
                date = new Date(mysqlDate[3], mysqlDate[2] - 1, mysqlDate[1], mysqlDate[4], mysqlDate[5], (mysqlDate[6] || 0));
            }
            else
            {
                date = new Date(mysqlDate[3], mysqlDate[2] - 1, mysqlDate[1]);
            }
        }
        else
        {
            let now = relationDate || new Date();

            let relationData = {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
                day: now.getDay(),
            };

            // check dayNames & dayNamesShort
            for (let idx in dayNamesShort)
            {
                if (!dayNamesShort.hasOwnProperty(idx) || parse.match(new RegExp('^' + dayNamesShort[idx] + '|' + dayNames[idx] + '$', 'i')) === null)
                {
                    continue;
                }

                let day    = parseInt(idx);
                let offset = 0;
                if (day > relationData.day)
                {
                    offset = day - relationData.day;
                }
                else
                {
                    offset = dayNamesShort.length - relationData.day + day;
                }

                now.setDate(now.getDate() + offset);
                date = now;
                break;
            }

            // check monthNames/monthNamesShort
            for (let idx in monthNames)
            {
                if (!monthNames.hasOwnProperty(idx))
                {
                    continue;
                }

                let month = parseInt(idx);
                let short = monthNamesShort[month];
                if (month === 2)
                {
                    short += '|mrz';
                }
                if (parse.match(new RegExp('^' + monthNames[month] + '|' + short + '$', 'i')) === null)
                {
                    continue;
                }

                let offset = 0;
                if (month > relationData.month)
                {
                    offset = month - relationData.month;
                }
                // less or equal
                else
                {
                    offset = monthNames.length - relationData.month + month;
                }

                now.setMonth(now.getMonth() + offset);
                date = now;
                break;
            }

            // no matched try parse
            if (date === false)
            {
                date = new Date(parse);
            }
        }
    }

    return date;
}

/**
 *
 * @param [format] {string}
 * The format of the outputted date string. See the formatting options below.
 * Default is "d.m.Y, H:i:s".
 * The following characters are recognized in the format parameter string:
 *
 *  <table>
 *   <tr>
 *     <th>Character</th>
 *     <th>Description</th>
 *     <th>Example</th>
 *   </tr>
 *   <tr>
 *     <td colspan="3"><b>Days</b></td>
 *   </tr>
 *   <tr>
 *     <td>d</td>
 *     <td>Day number, with leading zero</td>
 *     <td>01, 02, 10, 31 ...</td>
 *   </tr>
 *   <tr>
 *   <td>D</td>
 *   <td>short day name</td>
 *   <td>So, Mo, Di, Mi, ...</td>
 * </tr>
 * <tr>
 *   <td>j</td>
 *   <td>
 * An integer, between 1 and 31, representing the day of the month.</td>
 *   <td>1,2,...,31</td>
 * </tr>
 * <tr>
 *   <td>l (lowercase 'L')</td>
 *   <td>long day name</td>
 *   <td>Sonntag</td>
 * </tr>
 * <tr>
 *   <td>N</td>
 *   <td>day number of week (ISO-8601)</td>
 *   <td>1, 2, ..., 7</td>
 * </tr>
 * <tr>
 *   <td>S</td>
 *   <td>english day suffix, used for 1st, 2nd, 3rd, 4th</td>
 *   <td>st, nd, rd, th</td>
 * </tr>
 * <tr>
 *   <td>w</td>
 *   <td>day number of week</td>
 *   <td>0, 1, ..., 6</td>
 * </tr>
 * <tr>
 *   <td>N</td>
 *   <td>day number of year</td>
 *   <td>0, 1, ...</td>
 * </tr>
 * <tr>
 *   <td colspan="3"><b>Week</b></td>
 * </tr>
 * <tr>
 *   <td>W</td>
 *   <td>Week number of year (number or string)</td>
 *   <td>01, 02, ..., 11, 33</td>
 * </tr>
 * <tr>
 *   <td>Q</td>
 *   <td>get week with year</td>
 *   <td>2023W03, 2023W34</td>
 * </tr>
 * <tr>
 *   <td colspan="3"><b>Month</b></td>
 * </tr>
 * <tr>
 *   <td>F</td>
 *   <td>Month long name</td>
 *   <td>Januar</td>
 * </tr>
 * <tr>
 *   <td>m</td>
 *   <td>Month number with leading zero</td>
 *   <td>01, 02, ...,12</td>
 * </tr>
 * <tr>
 *   <td>M</td>
 *   <td>Month short name (3 Chars)</td>
 *   <td>Jan, Feb,...</td>
 * </tr>
 * <tr>
 *   <td>t</td>
 *   <td>Number of days in the given month</td>
 *   <td>1,2, ...,31</td>
 * </tr>
 * <tr>
 *   <td colspan="3"><b>Year</b></td>
 * </tr>
 * <tr>
 *   <td>L</td>
 *   <td>Leap year</td>
 *   <td>true, false</td>
 * </tr>
 * <tr>
 *   <td>o</td>
 *   <td>year number of last weeks friday (guessing from code)</td>
 *   <td>2022</td>
 * </tr>
 * <tr>
 *   <td>Y</td>
 *   <td>Year number</td>
 *   <td>2022</td>
 * </tr>
 * <tr>
 *   <td>y</td>
 *   <td>Two digit years number (string)</td>
 *   <td>12, 02, 99</td>
 * </tr>
 * <tr>
 *   <td colspan="3"><b>Time</b></td>
 * </tr>
 * <tr>
 *   <td>a</td>
 *   <td>Lowercase Ante meridiem (am) and Post meridiem (pm)</td>
 *   <td>am, pm</td>
 * </tr>
 * <tr>
 *   <td>A</td>
 *   <td>Uppercase Ante meridiem (am) and Post meridiem (pm)</td>
 *   <td>AM, PM</td>
 * </tr>
 * <tr>
 *   <td>B</td>
 *   <td>Swatch Internet time</td>
 *   <td>234</td>
 * </tr>
 * <tr>
 *   <td>g</td>
 *   <td>12-hour format of an hour without leading zeros</td>
 *   <td>1, ..., 12</td>
 * </tr>
 * <tr>
 *   <td>G</td>
 *   <td>24-hour format of an hour without leading zeros</td>
 *   <td>0,1,...,23</td>
 * </tr>
 * <tr>
 *   <td>h</td>
 *   <td>12-hour format of an hour with leading zeros</td>
 *   <td>01, 02, ..., 12</td>
 * </tr>
 * <tr>
 *   <td>H</td>
 *   <td>24-hour format of an hour with leading zeros</td>
 *   <td>00, 01, ..., 23</td>
 * </tr>
 * <tr>
 *   <td>i</td>
 *   <td>Minutes with leading zeros</td>
 *   <td>00, 01, ..., 59</td>
 * </tr>
 * <tr>
 *   <td>s</td>
 *   <td>Seconds, with leading zeros</td>
 *   <td>00, 01, ..., 59</td>
 * </tr>
 * <tr>
 *   <td>u</td>
 *   <td>Microseconds, with leading zeros</td>
 *   <td>000, 001,..., 010, 011, ..., 999</td>
 * </tr>
 * <tr>
 *   <td>e</td>
 *   <td>Timezone ???</td>
 *   <td>???</td>
 * </tr>
 * <tr>
 *   <td>I (uppercase 'i')</td>
 *   <td>???</td>
 *   <td>0, 1</td>
 * </tr>
 * <tr>
 *   <td>O</td>
 *   <td>???</td>
 *   <td>???</td>
 * </tr>
 * <tr>
 *   <td>P</td>
 *   <td>Time Zone offset</td>
 *   <td>+01:00, -02:00</td>
 * </tr>
 * <tr>
 *   <td>T</td>
 *   <td>???</td>
 *   <td>???</td>
 * </tr>
 * <tr>
 *   <td>Z</td>
 *   <td>???</td>
 *   <td>???</td>
 * </tr>
 * <tr>
 *   <td colspan="3"><b>Full Date/Time</b></td>
 * </tr>
 * <tr>
 *   <td>c</td>
 *   <td>ISO 8601 Date ('Y-m-d\\TH:i:sP')</td>
 *   <td>2023-06-12T12:34:12+02:00</td>
 * </tr>
 * <tr>
 *   <td>r</td>
 *   <td>RFC 2822 formatted date</td>
 *   <td>Tue Sep 05 2023 12:15:06 GMT+0200 (Mitteleuropäische Sommerzeit)</td>
 * </tr>
 * <tr>
 *   <td>U</td>
 *   <td>Unix timestamp</td>
 *   <td>1693908906</td>
 * </tr>
 * </table>
 * -----------------------------------------------------------
 * @param {*} [date] Date to format
 * @returns {boolean|number|string}
 */
export default function dateHelper(format = 'd.m.Y, H:i:s', date)
{
    let x = date;
    if (this instanceof Date)
    {
        /**
         * @this {Date}
         */
        date = this;
    }
    else
    {
        date = parseDate(date);
    }

    if (!date || 'Invalid Date' === date.toString())
    {
        return 'Invalid Date';
    }

    var
        /**
         *
         * @type {string}
         */returnStr = '',

        /**
         *
         * @type {{shortMonths: String[], longMonths: String[], shortDays: String[], longDays: String[], d: Function, D: Function, j: Function, l: Function, N: Function, S: Function, w: Function, z: Function, W: Function, F: Function, m: Function, M: Function, n: Function, t: Function, L: Function, o: Function, Y: Function, y: Function, a: Function, A: Function, B: Function, g: Function, G: Function, h: Function, H: Function, i: Function, s: Function, u: Function, e: Function, I: Function, O: Function, P: Function, T: Function, Z: Function, c: Function, r: Function, U: Function}}
         */
        replace      = dateFormat;

    // parse format
    for (var i = 0; i < format.length; i++)
    {
        var curChar = format.charAt(i);
        // escaped char
        if (i - 1 >= 0 && '\\' === format.charAt(i - 1))
        {
            returnStr += curChar;
        }
        else if ('undefined' !== typeof replace[curChar])
        {
            returnStr += replace[curChar].call(date);
        }
        else if (curChar !== '\\')
        {
            returnStr += curChar;
        }
    }

    return 'false' === returnStr ? false : ('true' === returnStr ? true : (isFinite(returnStr) && '0' != returnStr.charAt(0) && -1 === returnStr.indexOf('.')
        ? parseFloat(returnStr)
        : returnStr));
}

export function compareDate(datetime, operation = '=')
{
    let today         = dateHelper('Y-m-d');
    let datetimeParam = dateHelper('Y-m-d', datetime);

    switch (operation)
    {
        case '=':
            return datetimeParam === today;
        case '>=':
            return datetimeParam >= today;
        case '<':
            return datetimeParam < today;
        case '<=':
            return datetimeParam <= today;
        case '>':
            return datetimeParam > today;
        default:
            throw new Error('Invalid operation');
    }
}

export function isToday(datetime)
{
    return compareDate(datetime, '=');
}

export function isPast(datetime)
{
    return compareDate(datetime, '<');
}

export function timestamp(date)
{
    let timestamp = dateHelper('U', date);
    let x = timestamp;

    if ('boolean' === typeof timestamp)
    {
        timestamp = 0;
    }
    else if ('number' !== typeof timestamp)
    {
        timestamp = parseInt(timestamp);
    }

    return timestamp;
}